import React, { useEffect, useRef, useState } from 'react';
import { AutoComplete, Input, Spin } from 'antd';
import {
  CloseCircleFilled,
  DownOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import './styles.scss';

function SelectPwcUser({
  value: formValue,
  onChange,
  onUserChange,
  index,
  options,
  // onSearch,
  isLoading,
  // innerValue,
  setSearchValue,
  onBlur,
  hasGuid,
  curValue, // 判断是否显示placeholder以及autoComplete组件的value
  editInfo,
}) {
  const [focused, setFocused] = useState(false);
  // cache previous valid value to display in placeholder
  const [previousValue, setPreviousValue] = useState(formValue);
  const autoCompleteRef = useRef(null);
  const previousValueInitialized = useRef(false);

  const isDisabled = editInfo ? !editInfo.isNew : false;

  console.log('VALUE????? ', formValue);

  useEffect(() => {
    // initialize when guid exist
    if (hasGuid && !previousValueInitialized.current && formValue) {
      setPreviousValue(formValue);
      previousValueInitialized.current = true;
    }
  }, [hasGuid, formValue]);

  const onInputBlur = (e) => {
    setFocused(false);
    const matchedUser = options.find((i) => i.email === formValue);
    if (matchedUser && previousValue !== formValue) {
      const shouldUserChange = onUserChange(matchedUser, index);
      if (shouldUserChange) {
        setPreviousValue(previousValue);
      } else {
        setPreviousValue(null);
        // setSearchValue(null);
      }
    } else if (!formValue && previousValue) {
      // setSearchValue(previousValue);
      onChange(previousValue);
    } else if (formValue && formValue !== previousValue) {
      onUserChange(null, index, formValue, true);
      setPreviousValue(null);
    }
    if (typeof onBlur === 'function') {
      onBlur(e);
    }
    setSearchValue(null);
  };

  const onSelect = (value, obj) => {
    setSearchValue(value);
    typeof onChange === 'function' && onChange(value);
    const matchedUser = options.find((i) => i.email === value);
    const shouldUserChange = onUserChange(matchedUser, index);
    if (shouldUserChange) {
      setPreviousValue(value);
    } else {
      setPreviousValue(null);
    }
    setSearchValue(null);

    setTimeout(() => {
      const t = autoCompleteRef.current?.blur?.();
    }, 0);
  };

  const onFocus = (e) => {
    setFocused(true);
    if (previousValue) {
      onChange('');
      // setSearchValue(innerValue);
      // setSearchValue(null);
    }
    if (!hasGuid && formValue) {
      setSearchValue(formValue);
    }
  };

  const notFundElement =
    options && options.length === 0 && formValue?.length > 2 && !isLoading ? (
      <div style={{ textAlign: 'center' }}>Not found</div>
    ) : null;

  const onValueChange = (value) => {
    if (value === null || value === undefined) {
      // the clear icon is clicked
      onUserChange(null, index);
      setPreviousValue(null);
    }
    onChange(value);
    setSearchValue(value);
  };

  return (
    <AutoComplete
      // value={curValue}
      // disabled={hasGuid ? true : false}
      disabled={isDisabled}
      showSearch
      // searchValue={formValue}
      autoClearSearchValue={false}
      notFoundContent={
        isLoading ? (
          <Spin size="small" style={{ marginLeft: '48%' }} />
        ) : (
          notFundElement
        )
      }
      filterOption={false}
      // onSearch={onSearch}
      onChange={onValueChange}
      onSelect={onSelect}
      onFocus={onFocus}
      onBlur={onInputBlur}
      className="select-pwc-user"
      dropdownClassName="dropdown-box"
      allowClear
      clearIcon={<CloseCircleFilled style={{ fontSize: '1.25rem' }} />}
      ref={autoCompleteRef}
      options={options.map((d) => ({
        value: d.email,
        label: (
          <ul
            key={d.guid}
            style={{
              color: 'var(--selectUserDropdownMainColor)',
              lineHeight: '1.72rem',
              fontSize: '0.875rem',
            }}
          >
            <li
              style={{
                fontSize: '0.875rem',
                color: 'var(--selectUserDropdownEmailColor)',
                fontWeight: '500',
                fontStyle: 'italic',
              }}
            >
              {d.fullName}
            </li>
            <li className="li-head">{d.email}</li>
            <li>{d.staffLevel}</li>
            <li>
              {d.country}
              {d.department && `:${d.department}`}
            </li>
          </ul>
        ),
      }))}
    >
      <Input
        suffix={focused ? <SearchOutlined /> : <DownOutlined />}
        placeholder={curValue ? curValue : ''}
        // placeholder={curValue ? previousValue || curValue : ''}
        // value={formValue}
      />
    </AutoComplete>
  );
}

export default SelectPwcUser;
